import React from 'react'
import cn from 'classnames'

type Image = { url: string; alt: string }

export interface ThreeImagesProps {
  images: Image[]
  imageContainerClass?: string
  moreMargin?: boolean
  onRenderImage?: (image: { url: string; alt: string }) => JSX.Element
}

const ThreeImages = ({ images, imageContainerClass, moreMargin = false, onRenderImage }: ThreeImagesProps) => {
  // all three images have to be provided
  if (images.length !== 3) return null

  return (
    <div
      className={cn('container d-flex justify-content-between page-slice-spacer__smaller', {
        'mb-lg-6 mb-3': moreMargin
      })}
    >
      {images.map((image, i) => (
        <div
          key={i}
          className={cn(
            'w-100 overflow-hidden position-relative image-rounded three-images__image',
            imageContainerClass,
            {
              'mx-1 mx-lg-3': i === 1
            }
          )}
        >
          {onRenderImage ? (
            onRenderImage(image)
          ) : (
            <img src={image.url} alt={image.alt} className='mb-2 mb-lg-0 h-100 w-100' />
          )}
        </div>
      ))}
    </div>
  )
}

export default ThreeImages
